import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RatingTemplateActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/RatingTemplate/RatingTemplateBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceContent"
				RenderedComponent={this.RenderedComponent}
				context="ServiceContent"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RatingTemplateActivity)
